/**
 * Словарь подписей для экрана привязок.
 *
 * ВРЕМЕННЫЙ И ЭТО ОБЪЯВЛЕНО. Манифест несёт ключи локализации, а не готовый
 * текст: словари по решению Фазы 2 живут на сервере и меняются без пересборки
 * клиента (docs/ARCHITECTURE.md, 4.5). Серверные словари приходят в Фазе 4
 * вместе с Game SDK; до тех пор ключи фикстурных сцен переводятся здесь.
 *
 * Неизвестный ключ показывается КАК КЛЮЧ, а не как пустая строка: пустая
 * подпись выглядит дефектом вёрстки и не подсказывает, чего не хватает.
 */
const LABELS: Record<string, string> = {
  // Сцена «бегущая строка»
  'ticker.action.push': 'Ускорить строку',
  'ticker.effect.push': 'Строка бежит быстрее',
  'ticker.action.slowdown': 'Замедлить строку',
  'ticker.effect.slowdown': 'Строка бежит медленнее',
  'ticker.param.strength': 'Сила',
  'ticker.collection.lanes': 'Дорожки',
  'ticker.setting.speed': 'Скорость',
  'ticker.setting.endless': 'Бесконечный режим',
  'ticker.setting.roundSeconds': 'Длительность раунда, с',
  'ticker.setting.phrases': 'Свои фразы',
  'ticker.preset.giftHeavy': 'Гонка подарков',
  'ticker.chat.reason': 'Разбирает ответы зрителей из чата.',
  'ticker.keyword.go': 'го',

  // Сцена «пульс»
  'pulse.action.flash': 'Вспышка',
  'pulse.effect.flash': 'Экран вспыхивает',

  // Общее
  'quota.ownContent': 'Свои материалы',
};

/**
 * Серверный словарь текущей игры.
 *
 * ПОЧЕМУ МОДУЛЬНЫЙ, А НЕ КОНТЕКСТ. Экран показывает ровно одну игру за раз -
 * ту, что выбрана в overlay. Альтернатива - протащить функцию перевода через
 * пять компонентов подряд ради данных, которые на экране всегда одни. Как
 * только игр на экране станет две, это перестанет быть верным, и тогда здесь
 * появится контекст.
 *
 * Локальная таблица выше остаётся для фикстур: у них серверного словаря нет.
 */
let serverDictionary: Readonly<Record<string, string>> = {};

export function applyDictionary(dictionary: Readonly<Record<string, string>> | undefined): void {
  serverDictionary = dictionary ?? {};
}

export function label(key: string): string {
  return serverDictionary[key] ?? LABELS[key] ?? key;
}

/** Значения параметров-перечислений. */
const VALUES: Record<string, string> = {
  small: 'слабая',
  medium: 'средняя',
  large: 'сильная',
  top: 'верхняя',
  middle: 'средняя',
  bottom: 'нижняя',
};

export function valueLabel(value: string): string {
  return VALUES[value] ?? value;
}

/** Названия типов событий - словарь событий из docs/SPEC.md, 3.2. */
export const EVENT_LABELS: Record<string, string> = {
  gift: 'Подарок',
  comment: 'Комментарий',
  like: 'Лайк',
  follow: 'Подписка',
  share: 'Репост',
  join: 'Вход в эфир',
};

/**
 * Момент применения изменения состава коллекции.
 *
 * ПОКАЗЫВАЕТСЯ ЯВНО. У конкурента в `horse-race` добавленная дорожка
 * появляется только после перезапуска, а в `territory-war` - мгновенно с
 * автоперезапуском, и снаружи это неразличимо: добавленный элемент просто не
 * появляется, и пользователь считает, что не сработало
 * (`_REVISION_CANVAS_GROUP.md`, 2.1).
 */
export const APPLY_MOMENT_LABELS: Record<string, string> = {
  immediate: 'Применяется сразу',
  'immediate-with-restart': 'Применяется сразу, партия перезапустится',
  'next-round': 'Применится со следующего раунда',
  restart: 'Применится после перезапуска игры',
};

/*
 * Склонение по числу переехало в `lib/plural.ts` - оно нужно не только
 * привязкам, а формат обязан быть один на продукт. Здесь - переэкспорт,
 * чтобы не переписывать импорты ради переезда.
 */
export { coins, plural } from '../lib/plural';
